export const GLOBAL_SIDE_NAV_TEST_ID = 'global-side-nav-test-id';
export const PEEK_TEST_ID = 'gsn-peek';
export const SHORTCUTS_TEST_ID = 'gsn-global-shortcuts';
